import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import { Pressable } from "@/components/ui/pressable";
import { HStack } from "@/components/ui/hstack";
import ModalBase from "../components/modals/ModalBase";
import React from 'react'
import { useSelector } from "react-redux";
import { Linking } from "react-native";
import i18n from "i18n-js";
import { studioVersion } from "../algorithms_and_functions/studioVersion";

export default function HelpModal({ showModal, setShowModal }) {
    const user = useSelector((state) => state.user) || { name: 'Unkown', demo: true }

    const onClose = (isOk) => {
        setShowModal(false)
    }

    return (
        <ModalBase showModal={showModal} setShowModal={onClose} title={'sideNavigationDrawer.help'} onButton={onClose} buttonR={'global.ok'}>
            <VStack space='xl'>
                <Text className="text-2xl text-secondary-900">{i18n.t('helpScreen.supportContact')}</Text>
                <HStack space='lg' className="px-3">
                    <VStack space='md'>
                        <Text className="text-xl text-secondary-900">{i18n.t('helpScreen.website')}</Text>
                        <Text className="text-xl text-secondary-900">{i18n.t('helpScreen.email')}</Text>
                        <Text className="text-xl text-secondary-900">{i18n.t('helpScreen.tel')}</Text>
                    </VStack>
                    <VStack space='md'>
                        <Pressable onPress={() => Linking.openURL('https://ina.coach/')}>
                            <Text className="text-xl text-primary-900">ina.coach</Text></Pressable>
                        <Pressable onPress={() => Linking.openURL('mailto:hallo@ina.coach')}>
                            <Text className="text-xl text-primary-900">hallo@ina.coach</Text></Pressable>
                        <Pressable onPress={() => Linking.openURL('tel:+4971719789988')}>
                            <Text className="text-xl text-primary-900">+4971719789988</Text></Pressable>
                    </VStack>
                </HStack>
                <Text className="text-xl px-3 text-secondary-900">
                    {i18n.t('helpScreen.helperText1Studio')}
                    {user.demo ? i18n.t('helpScreen.helperText1Demo') : i18n.t('helpScreen.helperText1User')}
                    {!user.demo && <Text className="text-xl text-primary-900">
                        {user.mail ? ' ' + user.mail : ''}
                    </Text>}
                    {i18n.t('helpScreen.helperText2')}
                    <Text className="text-xl text-primary-900">
                        {studioVersion}
                    </Text>
                    {i18n.t('helpScreen.helperText3Studio')}
                </Text>
            </VStack>
        </ModalBase>
    );
}
